import { Menu } from 'lucide-react';
import { useAuthStore } from '@/store/auth.store';
import { useSidebarStore } from '@/store/sidebar.store';
import NotificationBell from '@/components/common/NotificationBell';
import ProfileMenu from '@/components/layout/ProfileMenu';

/**
 * The top bar follows the theme rather than being painted in the brand
 * colour. A charcoal band across a white page reads as heavy and dates the
 * app; worse, it forced one logo to work on a dark strip whatever the rest
 * of the page was doing. Light theme gets a light bar, dark gets a dark one,
 * and the logo in the sidebar is chosen to match.
 */
export default function Header() {
  const clientIp = useAuthStore((s) => s.clientIp);
  const openMobile = useSidebarStore((s) => s.openMobile);

  return (
    <header className="chrome flex h-16 items-center justify-between gap-2 border-b border-gray-200 bg-surface px-3 sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={openMobile}
          className="rounded p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700 md:hidden"
          aria-label="Open navigation"
        >
          <Menu className="h-5 w-5" />
        </button>
        {clientIp && (
          <span className="hidden truncate text-xs text-gray-400 sm:inline">
            Logged in from: {clientIp}
          </span>
        )}
      </div>
      <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
        <NotificationBell />
        {/* Theme and sign out live in here, so the header carries one control
            for "me" rather than three. */}
        <ProfileMenu onDark />
      </div>
    </header>
  );
}
